module.exports = "/images/icon-logo.svg?d1ef57571045a13a1b238a90e3c3d6a0";